import React, { Suspense } from 'react';
import ErrorBoundary from 'common/components/error-boundary';
import { PREPARER, SENDER } from 'hellospa/components/signature-request';
import EditorContext from './context';
import {
  FEATURE_TEMPLATE_ROLES, FEATURE_DATE_FORMAT,
  FEATURE_SENDER_ASSIGN, addFeature, removeFeature, FEATURE_EMBED,
  hasFeature, featureMap,
  FEATURE_CAN_ADD_SIGNER, FEATURE_EDIT_SIGNERS, FEATURE_EDIT_DOCUMENTS,
  FEATURE_ROTATE_PAGES, FEATURE_DROPDOWN,
  FEATURE_RADIO, FEATURE_CONDITIONAL_LOGIC, FEATURE_SIGNATURE_COLOR,
  FEATURE_HYPERLINKS, FEATURE_CONDITIONAL_LOGIC_NESTED, FEATURE_MASKED_FIELDS,
  FEATURE_TEMPLATE_ONE_OFF_FILE, FEATURE_AUTOFILL_FIELDS, FEATURE_PREVIEW, FEATURE_PREVIEW_ONLY,
  FEATURE_DOC_ACTIONS_ADD, FEATURE_DOC_ACTIONS_ROTATE, FEATURE_DOC_ACTIONS_REPLACE,
  FEATURE_DOC_ACTIONS_REORDER,
  FEATURE_ADVANCED_MERGE_FIELD,
} from './constants';


const EditorLayout = React.lazy(() => import(/* webpackChunkName: "hellospa-editor2" */'./editor-layout'));


// These MODE_ constants are just bundles of common features. If you have a new
// requirement that templates must do something, you probably want a new
// `FEATURE_` and to add it here. If the feature is applied based on some other
// criteria, make a new FEATURE_ and merge it into the appropriate mode with
// `addFeature(mode, FEATURE_MY_NEWFEATURE)` in
// src/hellospa/page/editor/index.jsx
export const MODE_EDIT = {
  ...FEATURE_EDIT_SIGNERS,
  ...FEATURE_CAN_ADD_SIGNER,
  ...FEATURE_EDIT_DOCUMENTS,
};


export const MODE_EDIT_TEMPLATE = {
  ...FEATURE_TEMPLATE_ROLES,
  ...FEATURE_SENDER_ASSIGN,
  ...FEATURE_EDIT_SIGNERS,
  ...FEATURE_CAN_ADD_SIGNER,
  ...FEATURE_EDIT_DOCUMENTS,
};

export const MODE_EDIT_TEMPLATE_LINK = FEATURE_TEMPLATE_ROLES;
/* eslint-enable no-bitwise */


export {
  PREPARER, SENDER, FEATURE_EMBED, FEATURE_DATE_FORMAT,
  addFeature, removeFeature, hasFeature, featureMap,
  FEATURE_CAN_ADD_SIGNER, FEATURE_EDIT_SIGNERS, FEATURE_EDIT_DOCUMENTS,
  FEATURE_ROTATE_PAGES, FEATURE_DROPDOWN, FEATURE_RADIO, FEATURE_CONDITIONAL_LOGIC,
  FEATURE_SIGNATURE_COLOR, FEATURE_HYPERLINKS, FEATURE_CONDITIONAL_LOGIC_NESTED,
  FEATURE_MASKED_FIELDS, FEATURE_SENDER_ASSIGN, FEATURE_TEMPLATE_ONE_OFF_FILE,
  FEATURE_TEMPLATE_ROLES, FEATURE_AUTOFILL_FIELDS, FEATURE_PREVIEW, FEATURE_PREVIEW_ONLY,
  FEATURE_DOC_ACTIONS_ADD, FEATURE_DOC_ACTIONS_ROTATE, FEATURE_DOC_ACTIONS_REPLACE,
  FEATURE_DOC_ACTIONS_REORDER, FEATURE_ADVANCED_MERGE_FIELD,
};

function Editor(props) {
  return (
    <EditorContext {...props}>
      <Suspense fallback="">
        <EditorLayout />
      </Suspense>
    </EditorContext>
  );
}


export default function EditorWithErrorBoundary(props) {
  return <ErrorBoundary><Editor {...props} /></ErrorBoundary>;
}
